module.exports = __webpack_public_path__ + "img/82.3a79b1b2.jpg";